export const forms = {
  is: {
    success: {
      title: "Takk fyrir!",
      close: "Loka",
      contact: "Takk fyrir skilaboðin! Við munum hafa samband við þig eins fljótt og auðið er.",
      quote: "Takk fyrir fyrirspurnina! Við munum senda þér tilboð eins fljótt og auðið er.",
      order: "Takk fyrir pöntunina! Við munum hafa samband við þig eins fljótt og auðið er til að hefja verkefnið.",
      serviceDesk: "Takk fyrir beiðnina! Við munum hafa samband við þig eins fljótt og auðið er."
    },
    labels: {
      name: "Nafn",
      email: "Netfang",
      phone: "Sími",
      company: "Fyrirtæki",
      subject: "Efni",
      message: "Skilaboð",
      submit: "Senda"
    }
  },
  en: {
    success: {
      title: "Thank you!",
      close: "Close",
      contact: "Thank you for your message! We will contact you as soon as possible.",
      quote: "Thank you for your inquiry! We will send you a quote as soon as possible.",
      order: "Thank you for your order! We will contact you shortly to begin the project.",
      serviceDesk: "Thank you for your request! We will contact you as soon as possible."
    },
    labels: {
      name: "Name",
      email: "Email",
      phone: "Phone",
      company: "Company",
      subject: "Subject",
      message: "Message",
      submit: "Submit"
    }
  },
  es: {
    success: {
      title: "¡Gracias!",
      close: "Cerrar",
      contact: "¡Gracias por tu mensaje! Nos pondremos en contacto contigo lo antes posible.",
      quote: "¡Gracias por tu consulta! Te enviaremos un presupuesto lo antes posible.",
      order: "¡Gracias por tu pedido! Nos pondremos en contacto contigo pronto para comenzar el proyecto.",
      serviceDesk: "¡Gracias por tu solicitud! Nos pondremos en contacto contigo lo antes posible."
    },
    labels: {
      name: "Nombre",
      email: "Correo electrónico",
      phone: "Teléfono",
      company: "Empresa",
      subject: "Asunto",
      message: "Mensaje",
      submit: "Enviar"
    }
  },
  da: {
    success: {
      title: "Tak!",
      close: "Luk",
      contact: "Tak for din besked! Vi vil kontakte dig hurtigst muligt.",
      quote: "Tak for din forespørgsel! Vi sender dig et tilbud hurtigst muligt.",
      order: "Tak for din ordre! Vi kontakter dig snart for at påbegynde projektet.",
      serviceDesk: "Tak for din anmodning! Vi vil kontakte dig hurtigst muligt."
    },
    labels: {
      name: "Navn",
      email: "E-mail",
      phone: "Telefon",
      company: "Virksomhed",
      subject: "Emne",
      message: "Besked",
      submit: "Send"
    }
  }
};